import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { marked } from 'marked';

/**
 * Escape text before feeding it to the markdown parser so raw HTML in stored
 * messages cannot execute when rendered.
 */
export function escapeHtmlForCopilotMarkdown(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function decorateRenderedCopilotMarkdown(renderedHtml: string): string {
  return renderedHtml
    .replace(/<table>/g, '<div class="message-table-wrapper"><table>')
    .replace(/<\/table>/g, '</table></div>')
    .replace(/<a href=/g, '<a target="_blank" rel="noopener noreferrer" href=');
}

/**
 * Renders Copilot message body for display (same rules as the sidebar chat).
 * Assistant messages use GitHub-flavored markdown; other roles are plain text with line breaks.
 */
export function renderCopilotMessageHtml(
  sanitizer: DomSanitizer,
  textContent: string,
  role: 'user' | 'assistant' | 'system'
): string {
  if (role !== 'assistant') {
    return escapeHtmlForCopilotMarkdown(textContent).replace(/\n/g, '<br>');
  }

  const rawHtml = marked.parse(escapeHtmlForCopilotMarkdown(textContent), {
    async: false,
    breaks: true,
    gfm: true
  });
  const renderedHtml = typeof rawHtml === 'string' ? rawHtml : '';
  const sanitizedHtml = sanitizer.sanitize(SecurityContext.HTML, renderedHtml) ?? '';

  return decorateRenderedCopilotMarkdown(sanitizedHtml);
}
